export const SIGNED_IN = "SIGNED_IN";
export const SIGNED_OUT = "SIGNED_OUT";
export const UPDATE_USER = "UPDATE_USER";
export const GET_CURRENT_USER = "GET_CURRENT_USER";
